import React, { useEffect, useState, useRef } from 'react'
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import { useSelector } from 'react-redux'
import { EditorState, convertFromRaw } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';

export const ClipContent = (props) => {

  const [listing] = useState(props.listing);
  const [editorState, setEditorState] = useState(null);
  const isAdmin = useSelector(state => state.isAdmin)
  const videoRef = useRef(null);
  // const isAutoPlayEnabled = props.currentIndex > 0 && props.hasFirstClipPlayed;
  // const [isPlaying, setIsPlaying] = useState(isAutoPlayEnabled);
  const [isMuted, setIsMuted] = useState({});
  const [isInitialMount, setIsInitialMount] = useState(true);
  const [isPlaying, setIsPlaying] = useState(false);

  // const handlePlayPause = () => {
  //   const video = document.getElementById('myVideo');
  //   if (video.paused) {
  //     console.log("Playing video");
  //     video.play();
  //     setIsPlaying(true);
  //     if (props.currentIndex === 0) {
  //       props.onFirstClipPlayed();
  //     }
  //   } else {
  //     console.log("Pausing video");
  //     video.pause();
  //     setIsPlaying(false);
  //   }
  // };

  const handlePlayPause = () => {
  const video = videoRef.current;
  if (!video) return;

  if (video.paused) {
    video.play();
    setIsPlaying(true);
  } else {
    video.pause();
    setIsPlaying(false);
  }
};


//   useEffect(() => {
//     const video = videoRef.current;

//     // Only run this logic once for the very first clip (index 0)
//     if (props.currentIndex === 0 && video) {
//       // Ensure the video is explicitly paused after it has loaded, 
//       // regardless of initial browser autoplay attempts.
//       video.pause();
//       // Set state to match the paused video element.
//       setIsPlaying(false);
//     }
//   }, [props.currentIndex, videoRef.current]);

//  useEffect(() => {
//     const video = videoRef.current;
    
//     // Autoplay only if:
//     // 1. It is NOT the first clip (currentIndex > 0)
//     // 2. AND the user has already played the first clip (hasFirstClipPlayed)
//     if (props.currentIndex > 0 && props.hasFirstClipPlayed) {
//         if (video) {
//             video.load(); 
//             video.play()
//                 .then(() => {
//                     setIsPlaying(true); 
//                 })
//                 .catch(error => {
//                     console.error("Autoplay prevented or failed for next clip:", error);
//                     setIsPlaying(false); 
//                 });
//         }
//     } else if (props.currentIndex > 0) {
//         // If it's a subsequent clip but the user hasn't played the first, keep it paused.
//         if (video) {
//              video.pause();
//              setIsPlaying(false);
//         }
//     }
    
//   }, [listing.hpId, props.currentIndex, props.hasFirstClipPlayed]);

useEffect(() => {
  const video = videoRef.current;
  if (!video) return;

  // Reset video when clip changes
  video.currentTime = 0;

  if (props.currentIndex === 0) {
    // First clip → stay paused
    video.pause();
    setIsPlaying(false);
  } else {
    // Any next clip → autoplay
    //video.muted = true; // REQUIRED for autoplay
    video.play()
      .then(() => {
        setIsPlaying(true);
      })
      .catch(() => {
        setIsPlaying(false);
      });
  }
}, [props.listing.hpId, props.currentIndex]);


  useEffect(() => {
    if (listing.listingType === 'clips') {
      if (listing.myvideos_content) {
        const con = JSON.parse(listing.myvideos_content)
        const contentState = convertFromRaw(con);
        setEditorState(EditorState.createWithContent(contentState))
      }
    }
  }, [listing]);


  if (!props.listing.hpId)
    return <> </>
  else {
    return (
      <div className='billBoard'>
        <div className='col-md-12 text-center'>
          {props.listing.elements.map((element, index) => (
            <div key={element.value + index} >
              {element.type === 'video' ?
                <div className="video-container">
                  <video
                    className='clip_video'
                    ref={videoRef}
                    src={process.env.REACT_APP_IMAGES_URL + element.value}
                    loop
                    id="myVideo"
                  //autoPlay
                  ></video>
                  {isPlaying ?
                    <button onClick={handlePlayPause} className="play-pause-button-desktop_pause">
                      <i className="fa fa-pause styled-icon"></i>
                    </button> :
                    <button onClick={handlePlayPause} className="play-pause-button-desktop_play">
                      <i className="fa fa-play styled-icon"></i>
                    </button>}
                </div> : null}
            </div>
          ))}
          {isAdmin && listing.myvideos_content !== '' && listing.listingType === 'clips' ?
            <div className="rdw-storybook-root">
              <Editor
                editorState={editorState}
                wrapperClassName="rdw-storybook-wrapper"
                readOnly
                toolbarHidden
              />
            </div> : null}
        </div>
      </div>
    )
  }
}

export default (ClipContent); 
